import { Stack, Text, Heading, List, Box, Tiles } from 'braid-design-system';
import queryString from 'query-string';
import Youtube from 'react-youtube';

import Routes from 'src/config/routes';
import { createDotNetLinkUrl } from 'src/utils';

import BulletLink from './components/BulletLink/BulletLink';
import Tool from './components/Tool/Tool';
import AdWritingSvg from './resources/AdWriting.svg';
import CalculatorSvg from './resources/Calculator.svg';
import ChecklistSvg from './resources/Checklist.svg';
import ScreeningSvg from './resources/Screening.svg';

import * as styles from './ToolsTab.css';

const ToolsTab = () => (
  <Stack space="xlarge">
    <Stack space="medium">
      <Heading level="2" component="h1">
        Tools to help you sell
      </Heading>
      <Text>
        Every business is unique and selling a business can be a daunting
        process. The tools and articles below are designed to help simplify
        things and provide a little guidance along the way.
      </Text>
    </Stack>

    <Tiles columns={{ mobile: 1, tablet: 4 }} space="small">
      <Tool
        enabled={true}
        svg={AdWritingSvg}
        label="Ad Writing Tips"
        destination={createDotNetLinkUrl(
          queryString.stringifyUrl({
            url: Routes.ASSET,
            query: { key: Routes.AD_WRITING_TIPS },
          }),
        )}
        description="An ad writing guide to help your business be found, gain attention and be desirable to prospective buyers."
        htag="ad-writing-tips"
        testId="ad-writing-tips"
      />

      <Tool
        enabled={true}
        svg={CalculatorSvg}
        label="Price Guide"
        destination={Routes.PRICE_GUIDE}
        description="A valuation calculator that provides a suggested price range for your business, based on your financials and historical SEEK Business data."
        htag="price-guide"
        testId="price-guide"
      />

      <Tool
        enabled={true}
        svg={ScreeningSvg}
        label="Buyer Screening Guide"
        destination={createDotNetLinkUrl(
          queryString.stringifyUrl({
            url: Routes.ASSET,
            query: { key: Routes.BUYER_SCREENING_GUIDE },
          }),
        )}
        description="A comprehensive guide to assessing potential business buyers when they make enquiries on your ad."
        htag="buyer-screening-guide"
        testId="buyer-screening-guide"
      />

      <Tool
        enabled={true}
        svg={ChecklistSvg}
        label="Business Sale Checklist"
        destination={createDotNetLinkUrl(
          queryString.stringifyUrl({
            url: Routes.ASSET,
            query: { key: Routes.BUSINESS_SALE_CHECKLIST },
          }),
        )}
        description="A checklist to help you confidently prepare for the final stages of selling and ensure you've covered all bases for closing the deal."
        htag="business-sale-checklist"
        testId="business-sale-checklist"
      />
    </Tiles>

    <Box
      borderRadius="large"
      overflow="hidden"
      width="full"
      style={{ maxWidth: 750 }}
    >
      <Box className={styles.container}>
        <Youtube videoId="VbF-wceZbqY" iframeClassName={styles.iframe} />
      </Box>
    </Box>

    <Stack space="medium">
      <Heading level="3" component="h2">
        Useful Articles
      </Heading>
      <List>
        <BulletLink suffix="how-to-sell-a-business-the-ultimate-guide" />
        <BulletLink suffix="how-long-does-it-take-to-sell-a-business" />
        <BulletLink suffix="quick-ways-to-value-your-business" />
        <BulletLink suffix="who-should-you-trust-when-selling-a-business" />
        <BulletLink suffix="checklist-for-selling-a-business" />
      </List>
    </Stack>
  </Stack>
);

export default ToolsTab;
